var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #2569f2;\n      }\n\n      .st0, .st1 {\n        fill-rule: evenodd;\n      }\n\n      .st1 {\n        fill: #f2f6ff;\n        stroke: #f2f6ff;\n        stroke-linecap: square;\n        stroke-miterlimit: 10;\n        stroke-width: .75px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,0C14.33,0,0,14.33,0,32s14.33,32,32,32,32-14.33,32-32S49.67,0,32,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.18,13.09h15.12c5.74,0,10.4,4.66,10.4,10.4s-4.66,10.4-10.4,10.4h-11.34v3.27h14.37v3.78h-14.37v9.97h-3.78v-9.97h-1.89v-3.78h1.89v-3.27h-1.89v-3.78h1.89V13.09ZM25.97,16.88h11.34c3.65,0,6.62,2.96,6.62,6.62s-2.96,6.62-6.62,6.62h-11.34v-13.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRub);
export default __webpack_public_path__ + "static/media/rub.066d2054a399de4b31a7fe33f139dc1a.svg";
export { ForwardRef as ReactComponent };